import React, { useEffect, useState } from 'react';
import Logo from './Logo';

const DISMISS_KEY = 'menbirinchi_pwa_dismiss';

function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

/**
 * Chrome/Edge/Android: native install via beforeinstallprompt.
 * iOS Safari: manual “Home Screen” hint (Apple blocks programmatic install).
 */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [showIos, setShowIos] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    try {
      if (sessionStorage.getItem(DISMISS_KEY) === '1') return;
    } catch (_) {
      /* ignore */
    }

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);

    const ua = window.navigator.userAgent || '';
    const isIos =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
    if (isIos && isSafari) {
      setShowIos(true);
      setVisible(true);
    }

    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall);
  }, []);

  const dismiss = () => {
    setVisible(false);
    setDeferred(null);
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (_) {
      /* ignore */
    }
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch (_) {
      /* ignore */
    }
    setDeferred(null);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="install-banner" role="dialog" aria-label="Ilovani o‘rnatish">
      <Logo size={40} className="install-logo" />
      <div className="install-banner-text">
        <strong>Menbirinchi</strong>
        {deferred ? (
          <span>Tezroq ochish uchun telefoningizga o‘rnating</span>
        ) : showIos ? (
          <span>
            Safari: <b>Ulashish</b> → <b>Add to Home Screen</b>
          </span>
        ) : (
          <span>Ilovani telefoningizga qo‘shing</span>
        )}
      </div>
      <div className="install-banner-actions">
        {deferred ? (
          <button type="button" className="install-btn" onClick={install}>
            O‘rnatish
          </button>
        ) : null}
        <button type="button" className="install-dismiss" onClick={dismiss} aria-label="Yopish">
          ✕
        </button>
      </div>
    </div>
  );
}
